import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { TrnxCommonTs } from './../../shared/common/trnxCommonTs';
import { VaultObjectgroupextractionService } from './vault-objectgroupextraction.service';
import { Actionbutton } from './../../shared/common/Actionbutton';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReportlinksserviceService } from './../reportlinks/reportlinksservice.service';
import { ErrorMessages } from './../../shared/common/errormessages';
import { constants } from './../../shared/common/contants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportingServiceService } from './../../shared/services/reporting-service.service';
import { validationmethod } from './../../shared/Validations/Validationmethods';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { DropdownCellRendererComponent } from './dropdowncompo';
import { InputCellRendererComponent } from './inputboxcellrendered';

import { firstValueFrom } from 'rxjs';
export interface selectedBtn {
  data: any;
}
@Component({
    selector: 'app-vaultobject-popup-screen-extractiongrp',
    templateUrl: './vaultobject-popup-screen-extractiongrp.component.html',
    styleUrls: ['./vaultobject-popup-screen-extractiongrp.component.scss'],
    standalone: false
})
export class VaultobjectPopupScreenExtractiongrpComponent implements OnInit {


  validations_form: UntypedFormGroup;
  ObjectGrid: any;
  paramstemp;
  ObjectsData: any = [];
  vaultGroup: any = []
  columnDefsForObjects;
  //  @modified by Aman Singh
  //  @date 20-05-2024
  //  @desc Added 2 new fields at obejct group level (extraction method and field from objectmetadata)

  reportCreationData = { "description": "", "groupname": "", objectid: [], "groupType": "Extraction Group", "groupExtractionType": "", "setsSplitRequired": "", 'sourceDNS': [],"csvtojsoncsvpartitionname":"","csvtojsonpartitionsubstringstartposition":"","csvtojsonpartitionsubstringlength":"","extractionsource":"","fieldsfromobjectmetadata":"","csvextractionsource":"","splitby":""};
  defaultColDef;
  rowSelection;
  allFields: any[];
  selectedFieldsData: any[];
  gridApiForTablesFields;
  selectedObject;
  selectObjectId: any;
  columnDefsForReportingConfiguration: any[];
  tableFields: any[];
  fieldsData: any[];
  tablefields: any;
  gridAPI;
  validation_messages
  // columnDefsForTablesFields;
  ngModelObjectTemporary;
  fieldsDataToRemove: any;
  selectedFieldsDataToPush: any = [];
  temp: any = [];
  selectedTableFields: any;
  gridApi;
  rowbindingdata;
  gridColumnApi;
  getdata: any = []
  backgroundColorScreen = "";
  buttonColor = "";
  columnDefsForSelectedFields: any;
  rowSelectionForTablesFields;
  components: any;
  isCheckboxSelected: boolean = false;
  // columnDefs;
  value
  retrieveObject: any = [];
  setObject: any = [];
  tableName = "";
  listObjectDropDown: any = [];
  ngModelObject = [];
  updateButton = false;
  allocateButtonsBoolean = false;
  backgroundColorButton = "";

  recordsStart = 0;
  retrieveNgModelCreation: any = [];
  gridColumnAPI;
  selectedObjects: any = [];
  buttonName: any = "Save";
  buttonNameClose;
  hide = false;
  eyeIcon = true;
  nextButton = true;
  parentUpdate;
  formValidCheckbox: UntypedFormGroup;
  formValid: UntypedFormGroup;
  screenTypeTOrM: any;
  nextSaveTOrM = "";
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  editmode;
  update
  selectedOptionForGrpExtrType;
  selectedOptionForsetSplitReq = 'Yes';
  selectedvalForIsParent = "";

  listOfSourceDNS: any = [];

  rowData;
  addBtn=false;
  dialogData : any={};
  selectedFileName='';
  objectGroupDataList: any[] = []; // Array to store group data
  sourceDnsForUploadTemplate;
 sourceDns : any=[];
  fileSelected=false;
  dropdownSelected = false;
  params;
  sourceEnvName;
  constructor(private dialogref: MatDialogRef<VaultobjectPopupScreenExtractiongrpComponent>, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private constants: constants, private msg: ErrorMessages, private fb: UntypedFormBuilder, private linkservice: ReportlinksserviceService, private localStorageSettings: LocalStorageSettingsService, private vaultObjectService: VaultObjectgroupextractionService, private trnxCommonTs: TrnxCommonTs, private commonService: CommonService, private chgd: ChangeDetectorRef,@Inject(MAT_DIALOG_DATA) public data: selectedBtn
  ) {
    this.validation_messages = this.msg.reportConfiguration;
    //this.onCellValueChanged = this.onCellValueChanged.bind(this);
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
      dropdown: DropdownCellRendererComponent,
      inputbox: InputCellRendererComponent

    }
    this.dialogData = data
  }



  formValidation() {
    this.validations_form = new UntypedFormGroup({
      groupname: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),
      description: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),

      sourceDNS: new UntypedFormControl('', [Validators.required]),
      groupExtractionType: new UntypedFormControl('', [Validators.required]),
      setsSplitRequired: new UntypedFormControl('', [Validators.required]),

      csvtojsoncsvpartitionname: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator,this.validation.specialCharacterValidator]),
      csvtojsonpartitionsubstringstartposition: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      csvtojsonpartitionsubstringlength: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      extractionsource: new UntypedFormControl('', [Validators.required]),
      fieldsfromobjectmetadata: new UntypedFormControl('', [Validators.required]),
      csvextractionsource:new UntypedFormControl('', [Validators.required]),
      splitby:new UntypedFormControl('', [Validators.required]),


    });
  }

  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl(false, [Validators.requiredTrue])
    });
  

  }

  ngOnInit() {
    this.dialogData = this.data
    console.log("add record ==>> "+ this.dialogData.createGroupOption)
    if(this.dialogData.createGroupOption == "add btn"){
      this.addBtn = true;
    }
    console.log()
    this.validations_form = this.fb.group({
      groupname: '',
      description: '',
      sourceDNS : '',
      groupExtractionType: '',
      setsSplitRequired: '',
      csvtojsoncsvpartitionname: "",
      csvtojsonpartitionsubstringstartposition: "",
      csvtojsonpartitionsubstringlength:"",
      extractionsource: '',
      fieldsfromobjectmetadata: '',
      csvextractionsource: '',
      splitby:'',
    });

    // While unit testing it is added.
    this.formValidCheckbox = this.fb.group({
      isCheckboxSelected: ''
    });

    // this.lookupVaultGroup();

    this.columnDefsForObjects = [
      {
        headerName: "Objects",
        headerTooltip: "Objects",
        tooltipValueGetter: params => "Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 250,
        headerClass: 'headerClassName',
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Objects",
        headerTooltip: "Selected  Objects",
        tooltipValueGetter: params => "Selected  Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 200,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      },
      {

        headerName: "Object Name",
        headerTooltip: "Object Name",
        tooltipValueGetter: params => "Object Name" + params.value,
        field: "fileName",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateObjectnameValue.bind(this)
        }
      },
      {
        headerName: "IsParent",
        headerTooltip: "IsParent",
        tooltipValueGetter: params => "IsParent: " + params.value,
        field: "isParent",
        filter: "agTextColumnFilter",
        width: 160,
        cellRenderer: "dropdown",
        cellRendererParams: {
          edit: this.updateParentValue.bind(this)

        },
        // //headerCheckboxSelectionFilteredOnly: true,
        // cellRendererFramework: DropdownCellRendererComponent,
        // onCellValueChanged(event: any) {
        //   console.log('Selected value:', event.value);
        //   // Add your logic here to handle the selected value
        // },

        // cellStyle: { " padding-left": "5px" }
      },
      {
        headerName: "Filter Criteria For Extraction",
        headerTooltip: "Filter Criteria For Extraction",
        tooltipValueGetter: params => "Filter Criteria For Extraction : " + params.value,
        field: "filterCriteriaForExtr",
        filter: "agTextColumnFilter",
        width: 260,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.setFilterCriteriaForExtrac.bind(this)
        },
        //cellEditor: 'agTextCellEditor',
        // editable: true,
        // cellEditor: 'requiredCellEditor',
        // cellEditorParams: {
        //     requiredMessage: 'This field is required.'
        // },
        // cellStyle: { " padding-left": "5px" }
      },
      {
        headerName: "Query Criteria",
        headerTooltip: "Query Criteria",
        tooltipValueGetter: params => "Query Criteria : " + params.value,
        field: "vqlCriteria",
        filter: "agTextColumnFilter",
        width: 260,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.setVqlCriteria.bind(this)
        },
      },
      {

        headerName: "Query Criteria for Incremental Extraction",
        headerTooltip: "Query Criteria for Incremental Extraction",
        tooltipValueGetter: params => "Query Criteria for Incremental Extraction : " + params.value,
        field: "vqlCriteriaForIncre",
        filter: "agTextColumnFilter",
        width: 260,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.setVqlCriteriaForIncre.bind(this)
        }
      },
      {

        headerName: "Set Split Field Name",
        headerTooltip: "Set Split Field Name",
        tooltipValueGetter: params => "Set Split Field Name" + params.value,
        field: "setSplitObject",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateSetSplitObjectValue.bind(this)
        }
      },
      {

        headerName: "Global Extraction Object Reference",
        headerTooltip: "Global Extraction Object Reference",
        tooltipValueGetter: params => "Global Extraction Object Reference" + params.value,
        field: "globalExtractionObject",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateGlobalExtractionObjectValue.bind(this)
        }
      },
      {

        headerName: "Global Extraction Object Reference Field",
        headerTooltip: "Global Extraction Object Reference Field",
        tooltipValueGetter: params => "Global Extraction Object Reference Field" + params.value,
        field: "globalExtractionObjectField",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateGlobalExtractionObjectFieldValue.bind(this)
        }
      },
      {

        headerName: "Extraction Object Reference",
        headerTooltip: "Extraction Object Reference",
        tooltipValueGetter: params => "Extraction Object Reference" + params.value,
        field: "extractionObject",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateExtractionObjectValue.bind(this)
        }
      },
      {

        headerName: "Extraction Object Reference Field",
        headerTooltip: "Extraction Object Reference Field",
        tooltipValueGetter: params => "Extraction Object Reference Field" + params.value,
        field: "extractionObjectField",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateExtractionObjectFieldValue.bind(this)
        }
      },
      {

        headerName: "File Name",
        headerTooltip: "File Name",
        tooltipValueGetter: params => "File Name" + params.value,
        field: "filename",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateFileNameValue.bind(this)
        }
      },
      {

        headerName: "Level",
        headerTooltip: "Level",
        tooltipValueGetter: params => "Level" + params.value,
        field: "level",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateLevelValue.bind(this)
        }
      },
      {

        headerName: "Parent Object File Name",
        headerTooltip: "Parent Object File Name",
        tooltipValueGetter: params => "Parent Object File Name" + params.value,
        field: "parentobjectfilename",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateParentObjectFilename.bind(this)
        }
      },
      {

        headerName: "Parent Object Key Column",
        headerTooltip: "Parent Object Key Column",
        tooltipValueGetter: params => "Parent Object Key Column" + params.value,
        field: "parentobjectkeycolumn",
        filter: "agTextColumnFilter",
        width: 200,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateparentobjectkeycolumn.bind(this)
        }
      },
      
      {
        headerName: "Required In DataLake",
        headerTooltip: "Required In DataLake",
        tooltipValueGetter: params => "Required In DataLake: " + params.value,
        field: "requiredInDataLake",
        filter: "agTextColumnFilter",
        width: 160,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updateRequiredInDatalake.bind(this)

        }
      }
,
      
      {
        headerName: "Refresh in Incremental",
        headerTooltip: "Refresh in Incremental",
        tooltipValueGetter: params => "Refresh in Incremental: " + params.value,
        field: "refreshInIncremental",
        filter: "agTextColumnFilter",
        width: 160,
        cellRenderer: "inputbox",
        cellRendererParams: {
          edit: this.updaterefreshInIncremental.bind(this)

        }
      }

    ];

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields = 'multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    // save and update button toggle
    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;
    }

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    console.log(this.buttonName);

    this.formValidationsCheckbox();
    this.formValidation();

    //To different master and transaction screens.
    // if (this.screenTypeTOrM == "Transaction") {

    //   this.nextSaveTOrM = "Next";

    // }

    // else {

    //   this.nextSaveTOrM = "Save";

    // }
    // this.reportCreationDuplicate.push();

    this.retrieveSourceDNS();
    console.log("--------")
    
  }

  onGridReady(params) {
    this.params = params;
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.linkservice.retrievereportlinks().subscribe(response => {
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)

      }
      this.spinner.stop();
    });
  }

  async onGridReadyForObjects(params) {
    console.log("i am from onGridReadyForObjects---first grid")
    this.tableFields = [];
    this.selectedObjects = [];
    this.ObjectGrid = params;
    // this.spinner.start();
    // let tableName = "objectmetadata";
    // let response = await this.commonService.retrieveRecordService(tableName);
    // this.ObjectGrid.api.setGridOption('rowData', response);
    // if (tableName === undefined) {
      this.ObjectGrid.api.setGridOption('rowData', []);
    // } else {
    // }
    this.gridApiForTablesFields = params;
    this.gridApiForTablesFields = params.api;

  }



  onRowSelected(event) {

    this.fieldsData = this.ObjectGrid.api.getSelectedRows();

    const updatedRows = this.fieldsData.map(row => ({
      ...row, // Spread existing properties
      isParent: 'No', // Add new key-value pairs
      filterCriteriaForExtr: '',
      vqlCriteria: "",
      vqlCriteriaForIncre: ""
    }));



    updatedRows.forEach(item => {
      let exists = this.selectedObjects.some(selected => selected.id === item.id);
      if (!exists) {
        this.selectedObjects.push({ ...item });
      }
    });

    console.log(this.fieldsData);


    this.fieldsData = this.selectedObjects;
    //if we comment this then in during creation of new object group even though the objects are deselected it will push to right side grid
    this.selectedObjects = updatedRows;

    console.log(this.selectedObjects);
  }

  onGridReadyForSelectedTableFields(params, data) {
    this.selectedTableFields = params
    this.selectedFieldsDataToPush = data;
    // console.log(this.selectedFieldsDataToPush);
    //this.gridApiForTablesFields = params.api;
    console.log(data);
    console.log(this.selectedTableFields)

    this.selectedTableFields.api.setGridOption('rowData', data);
    //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

  }

  //forward Icon Function decleation
  pushDataToSelectedFieldsGrid() {
    this.fieldsDataToRemove = [];
    let uniq = {}
    console.log(this.selectedObjects, 'selected objects', 'pushDataToSelectedFieldsGrid');
    for (let i = 0; i < this.selectedObjects.length; i++) {
      console.log("table fields length =", this.tableFields.length)
      console.log(this.selectedObjects[i])
      let obje = {
        objectid: this.selectedObjects[i].id,
        isParent: this.selectedObjects[i].isParent,
        filterCriteriaForExtraction: this.selectedObjects[i].filterCriteriaForExtr,
        vqlCriteria: this.selectedObjects[i].vqlCriteria,
        vqlCriteriaForIncremental: this.selectedObjects[i].vqlCriteriaForIncre,
        setSplitObject: this.selectedObjects[i].setSplitObject,
        fileName: this.selectedObjects[i].objectname,
        globalExtractionObject: this.selectedObjects[i].globalExtractionObject,
        globalExtractionObjectField: this.selectedObjects[i].globalExtractionObjectField,
        extractionObject: this.selectedObjects[i].extractionObject,
        extractionObjectField: this.selectedObjects[i].extractionObjectField,
        sourceDnsId : this.selectedObjects[i].tenantid,
        filename : null,
        level:null,
        parentobjectfilename:null,
        parentobjectkeycolumn:null,
        refreshInIncremental:this.selectedObjects[i].refreshInIncremental,
        requiredInDataLake:this.selectedObjects[i].requiredInDataLake

      }
      this.reportCreationData.objectid.push(obje)
    }
    this.reportCreationData.objectid = this.reportCreationData.objectid.filter(
      (item, index, self) => index === self.findIndex(obj => obj["objectid"] === item["objectid"])
    );
    console.log('report creation data s', this.reportCreationData)
    this.rowData = this.selectedObjects;
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedObjects.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
    for (let i = 0; i < this.temp.length; i++) {
      this.temp[i].fileName = this.temp[i].objectname;
    }
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);

  }

  //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    this.fieldsDataToRemove = [];
    let uniq = {}




    for (let field of this.tablefields) {

      let obje = {
        objectid: field.id,
        isParent: "No",
        filterCriteriaForExtraction: "",
        vqlCriteria: "",
        vqlCriteriaForIncremental: "",
        setSplitObject: "",
        fileName: "",
        globalExtractionObject: "",
        globalExtractionObjectField: "",
        extractionObject: "",
        extractionObjectField: ""
      }
      //console.log('obje valueee=========', obje)
      this.reportCreationData.objectid.push(obje)
      //  console.log('report creation data', this.reportCreationData)

      field["isParent"] = "No"
      field["filterCriteriaForExtr"] = ""
      field["vqlCriteria"] = ""
      field["vqlCriteriaForIncre"] = ""
      field["setSplitObject"] = ""
      field["fileName"] = ""
      field["globalExtractionObject"] = ""
      field["globalExtractionObjectField"] = ""
      field["extractionObject"] = ""
      field["extractionObjectField"] = ""

    }
    console.log(this.reportCreationData);
    this.reportCreationData.objectid = this.reportCreationData.objectid.filter(
      (item, index, self) => index === self.findIndex(obj => obj["objectid"] === item["objectid"])
    );
    console.log(this.reportCreationData);
    // //duplicates data not allowed
    console.log(this.temp)

    this.temp = this.tablefields.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
    console.log(this.temp)
    console.log(this.selectedObjects)
    console.log(this.selectedObjects.length)
    const updatedtemp =[];


    this.temp.forEach(item => {
      let exists = this.selectedObjects.some(selected => selected.id === item.id);
      if (!exists) {
        this.selectedObjects.push({ ...item });
      }
    });
    this.temp = this.selectedObjects
    for (let i = 0; i < this.temp.length; i++) {
      this.temp[i].fileName = this.temp[i].objectname;
    }
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.selectedObjects)
    //this.pushDataToSelectedFieldsGrid();
    this.ObjectGrid.api.forEachNode(node => {

      node.setSelected(true)

    })
  }

  //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedObjects.length = 0
    this.temp.length = 0
    this.reportCreationData.objectid = [];
    console.log(this.selectedObjects)
    console.log(this.reportCreationData)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, [])
    // this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.ObjectGrid.api.forEachNode(node => {

      node.setSelected(false)

    })
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    let idsToRemove = this.fieldsDataToRemove.map(item => item.id);
    this.reportCreationData.objectid = this.reportCreationData.objectid.filter(item => !idsToRemove.includes(item.objectid));
    console.log(this.reportCreationData)
    console.log(this.temp)
    this.selectedObjects= this.temp;
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)

    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    for (let o = 0; o < this.fieldsDataToRemove.length; o++) {
      this.ObjectGrid.api.forEachNode(node => {
        if (node.data.objectlabel === this.fieldsDataToRemove[o].objectlabel) {
          node.setSelected(false)
        }
      })
    }
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }



  save() {
    this.validations_form.markAllAsTouched();
this.formValidCheckbox.markAllAsTouched();
if (this.validations_form.invalid ) {
  this.snackbar.open("Please fill all required fields", "OK", { duration: 5000 });
  return;
}
    console.log("selectedobjects==00  =====" + this.selectedObjects.toLocaleString());

    console.log("selectedFieldsDataToPush=====" + this.selectedFieldsDataToPush);
    console.log(this.isCheckboxSelected);
    console.log(this.reportCreationData);

    if(this.tablefields.length == 0){
      this.snackbar.open("Objects Cannot be empty. Select atleast one bject to create group", "OK", {duration:5000});
      return;
    }
    // checking if any object has duplicate filename
    const validFilenames = this.selectedObjects
    .map(obj => obj.filename?.trim())        // extract + trim
    .filter(name => name);                   // remove null, undefined, ""

const hasDuplicate = new Set(validFilenames).size !== validFilenames.length;

if (hasDuplicate) {
     alert("Duplicate filename not allowed! Please either leave it blank or provide a distinct filename.");
   return;
}

const levelMap = new Map<number, string>(); // Map<level, tenantId>

for (const obj of this.selectedObjects) {
  const tenantId = obj.tenantid;
  const levelValue = obj.level;

  // Skip empty levels
  if (levelValue === null || levelValue === undefined || levelValue === '') continue;
  if(levelValue===0 || levelValue ==='0')
{
  alert("Level should be 1 or greater. Level 0 is not allowed.");

}
  // Validate numeric
  const levelNum = Number(levelValue);
  if (isNaN(levelNum)) {
alert("Level value should be a valid number");
    return;
  }

  // Check if same level exists for a different tenant
  if (levelMap.has(levelNum) && levelMap.get(levelNum) !== tenantId) {
   alert(
     `Level value '${levelValue}' must be unique across different sources`
    );
    return;
  }

  // Store mapping of level → tenantId
  levelMap.set(levelNum, tenantId);
}

const invalidObjects = this.selectedObjects.filter(obj => {
  const isLevelOne = Number(obj.level) === 1;
  const hasParentFileName = obj.parentobjectfilename && obj.parentobjectfilename.trim() !== "";
  const hasParentKeyColumn = obj.parentobjectkeycolumn && obj.parentobjectkeycolumn.trim() !== "";

  // if level 1 and any of these fields has a value -> invalid
  return isLevelOne && (hasParentFileName || hasParentKeyColumn);
});

if (invalidObjects.length > 0) {
  alert(
    "For level 1, parentobjectfilename and parentobjectkeycolumn are not required."
  );
  return;
}

    for (let a = 0; a < this.selectedObjects.length; a++) {
      if (this.selectedObjects[a].filterCriteriaForExtr === "") {
        alert(`Filter Criteria For Extraction cannot be empty for ${this.selectedObjects[a].objectlabel}`)
        return;
      }
      if (this.selectedObjects[a].vqlCriteria === "") {
        alert(`Query Criteria cannot be empty for ${this.selectedObjects[a].objectlabel}`)
        return;
      }

      if (this.selectedObjects[a].vqlCriteriaForIncre === "") {
        alert(`Query Criteria for Incremental Extraction cannot be empty for ${this.selectedObjects[a].objectlabel}`)
        return;
      }

      if(this.selectedObjects[a].isParent ==="Yes" && this.selectedObjects[a].level !== '1'){
        alert("Level should be 1 for parent object.")
        return
      }
    const ril = this.selectedObjects[a].refreshInIncremental;
    if (ril !== null && ril !== undefined && String(ril).trim() !== '') {
      const val = String(ril).trim();
      if (val !== 'Yes' && val !== 'No') {
        alert("Value should be Yes/No in Refresh in Incremental field.");
        return;
      }
    }

    const rid = this.selectedObjects[a].requiredInDataLake;
    if (rid !== null && rid !== undefined && String(rid).trim() !== '') {
      const valRid = String(rid).trim();
      if (valRid !== 'Yes' && valRid !== 'No') {
      alert("Value should be Yes/No in Required In DataLake field.");
      return;
      }
    }
      const obj = this.selectedObjects[a];

const parentFile = obj.parentobjectfilename;
const parentKey  = obj.parentobjectkeycolumn;

// Trim values safely (handle null/undefined)
const parentFileVal = parentFile ? parentFile.trim() : "";
const parentKeyVal  = parentKey  ? parentKey.trim()  : "";

// Check: if one is filled but the other is empty → show alert
if ((parentFileVal !== "" && parentKeyVal === "") || 
    (parentKeyVal !== "" && parentFileVal === "")) {
    
    alert(`Both Parent Object Filename and Parent Object Key Column are required together for ${obj.objectlabel}`);
    return;
}

    }

    this.spinner.start();
  
    let reportCreationDataList = [this.reportCreationData];
    this.vaultObjectService.insertMstrObjectGroup(reportCreationDataList).subscribe(response => {
      // this.spinner.start();
      console.log(response)
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,

        });
        this.spinner.stop();
      }
      else if (this.isCheckboxSelected == true) {
        this.reportCreationData.objectid = [];
        this.validations_form.reset();
        this.formValidCheckbox.reset();
        this.ObjectGrid.api.deselectAll();
        this.selectedObjects = [];
        this.selectedTableFields.api.setGridOption('rowData', []);
        // this.ObjectGrid.api.setGridOption('rowData', []);
        let tableName = "objectsmetadatamstr";
        let response = this.commonService.retrieveRecordService(tableName);
        this.snackbar.open('Object Group created successfully', "OK", {
          duration: 5000,
        });
        this.ObjectGrid.api.setRowData.reset();
        if (tableName === undefined) {
          this.ObjectGrid.api.setRowData.reset();
        } else {
          this.tablefields = response;
          console.log(this.tablefields)
          this.ObjectGrid.api.setRowData.reset();
          this.selectedObjects.api.setRowData.reset();
        }
        // this.gridApiForTablesFields.setRowData.reset();
        // this.fieldsData = this.ObjectGrid.api.getSelectedRows.reset();
        // this.selectedObjects = this.fieldsData;
      }
      else {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        window.location.reload();
        this.dialogref.close();
        this.cancel();
      }
      // this.spinner.stop();
      // this.onGridReady(this.rowbindingdata);

      console.log(this.isCheckboxSelected);
      // this.isCheckboxSelected = true;
      // if (this.isCheckboxSelected == true){
      //   this.validations_form.reset();
      //   this.formValidCheckbox.reset();
      // }
      // else{
      //   this.dialogref.close();
      //   this.cancel();
      //   // this.reportCreationDuplicate.push(response);
      //   // this.spinner.start();
      // }
      this.spinner.stop();

    });
    // this.cancel();
  }


  // async next(value) {
  //   console.log(value)
  //   // checking the form is valid or not while insert
  //   if (!this.formValid.valid) {

  //     // displaying validation messages

  //     this.validation.validateAllFormFields(this.formValid);

  //     this.validation.getvalidationmessage();

  //   }
  // }

  close() {
    console.log(this.isCheckboxSelected);
    console.log(typeof this.isCheckboxSelected);
    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.validations_form.reset();
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      // this.reportCreationData = [];

      this.dialogref.close();

    }
  }
  cancel() {
    // this.formValidCheckbox.reset();
    // this.formValidationsCheckbox();
    this.isCheckboxSelected = false;
    this.reportCreationData = {
      description: "",
      groupname: "",
      objectid: [],
      groupType: "",
      groupExtractionType: "",
      setsSplitRequired: "",
      sourceDNS : [],
      csvtojsoncsvpartitionname:"",
      csvtojsonpartitionsubstringstartposition:"",
      csvtojsonpartitionsubstringlength:"",
      extractionsource:"",
      fieldsfromobjectmetadata:"",
      csvextractionsource:"",
      splitby:"",
    }
    this.dialogref.close();

    this.close();
    window.location.reload();
  }
  onSelectionChange() {
    console.log("===========grp extr============" + this.reportCreationData.groupExtractionType)
    console.log("========================" + this.reportCreationData.groupType)
    console.log("========================" + this.reportCreationData.setsSplitRequired)

  }


  updateParentValue(value, id, params) {

    console.log(value);
    console.log(params)
    console.log(this.selectedObjects)
    if (value == "Yes") {
      let filteredObj = this.selectedObjects.filter(obj => obj.isParent == "Yes");
      if (filteredObj.length >= 1) {

        alert("Multiple parent objects cannot be selected in a group")

        return "No";
      }
    }


    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].isParent = value
        this.chgd.detectChanges()
        break;
      }
    }
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].isParent = value
        this.reportCreationData.objectid[i].level='1' // for parent object level should be always 1
        break;
      }
    }
    console.log("selected object from update parent value", this.selectedObjects)

  }

  setFilterCriteriaForExtrac(value, id) {
    console.log(value, id, "====================")
    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].filterCriteriaForExtr = value
        break;
      }
    } console.log("selected object from setFilterCriteriaForExtrac", this.selectedObjects)

    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].filterCriteriaForExtraction = value
        break;
      }
    }

  }
  setVqlCriteria(value, id) {
    console.log(value, id, "====================")
    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].vqlCriteria = value
        break;
      }
    }
    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].vqlCriteria = value
        break;
      }
    }
  }

  setVqlCriteriaForIncre(value, id) {
    console.log(value, id, "====================")
    for (let i = 0; i < this.selectedObjects.length; i++) {
      if (this.selectedObjects[i].id == id) {
        this.selectedObjects[i].vqlCriteriaForIncre = value
        break;
      }
    } console.log("selected object from setVqlCriteriaForincre", this.selectedObjects)

    for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
      if (this.reportCreationData.objectid[i].objectid == id) {
        this.reportCreationData.objectid[i].vqlCriteriaForIncremental = value
        break;
      }
    }

  }

  retrieveSourceDNS(){
    let workspaceid = this.localStorageSettings.getSettings('WorkspaceId');

    this.service.retrieveSourceDNSByWorkspaceId(workspaceid).subscribe((res:any)=>{
      if(res == undefined || res == null){
        this.snackbar.open("Source DNS not found. Please configure atleast one dns as source to continue.", "OK", {duration: 5000});
      } else{
        console.log(res);
         this.listOfSourceDNS = res;
        console.log("=======================")
        if (this.listOfSourceDNS && this.listOfSourceDNS.length > 0) {
          this.reportCreationData.sourceDNS = this.listOfSourceDNS[0].vaultConfigMstrId;
          this.sourceEnvName = this.listOfSourceDNS[0].envName;
          this.onSelectionSourceDNSForTemplate();

          this.sourceDnsForUploadTemplate = this.listOfSourceDNS[0].vaultConfigMstrId;
          this.sourceDns = this.listOfSourceDNS.map(source => source.vaultConfigMstrId);

          console.log(this.sourceDnsForUploadTemplate)
         // this.onSelectionSourceDNS();
        }
      }
    })
  }

  onSelectionSourceDNS() {
    console.log("=============")
   
    this.tablefields = [];
    
    this.ObjectGrid.api.setGridOption('rowData', []);
    let dnsName = this.reportCreationData.sourceDNS;
     let dnsids = dnsName.join(",");
    console.log(dnsids)
    this.spinner.start();
    this.service.retrieveObjectsByMultipleDnsId(dnsids).subscribe((res:any) =>{
      this.spinner.stop();
      console.log(res);
      if (res === null || res.length == 0){
        this.snackbar.open("No Metadata Available for Selected DNS", "OK", {duration: 5000});
      }else{
        this.tablefields = res;
        console.log(this.tablefields);
        this.ObjectGrid.api.setGridOption('rowData', this.tablefields);
      }
    })
  }


async onFileSelected(event: any) {
  this.objectGroupDataList = []; 


  const dropDownValues = ["Yes","No"];
  const extractionMethod =["Loader","VQL"];
  const extractiontype = ["Full","Partial"];
  const splitby=["id","case_number__v","local_case__v"]

  console.log("Inside on File select");
  this.selectedFileName=''
  if (event.target.files.length === 0) {
      return;
  }

  const file = event.target.files[0];
  const fileName = file.name;
  console.log("File Name:", fileName);

  const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
  console.log("File Extension:", fileExtension);

  if (fileExtension !== 'csv') {
      this.snackbar.open("Please choose a CSV file.", "OK", {
          duration: 5000,
      });
      return;
  }

  this.selectedFileName = fileName;
  console.log("Inside else, processing file...");
 this.fileSelected = true;
  const reader = new FileReader();
  this.spinner.start();
  reader.onload = async (e: any) => {
    const requiredColumns = ["object_name","group_name","description","group_extraction_type","split_required","isParent","fields_from_objectMetadata","extraction_source","csv_extraction_source","filter_criteria_for_extraction","vql_criteria_for_extraction","vql_criteria_for_incremental","partition_by","partition_start_position","partition_length","create_group","splitby",
      "fileName","setSplitObject","globalExtractionObjectField","globalExtractionObject","extractionObject","extractionObjectField","dnsName"
      ,"parentobjectfilename","parentobjectkeycolumn","level","requiredInDataLake","refreshInIncremental"
    ]
    const headerColumnInCSV = []
      const csvContent = e.target.result;
      const rows = csvContent.split('\n').map(row => row.trim()).filter(row => row); // Remove empty rows
      if (rows.length === 0) {
        this.snackbar.open(
            "The uploaded CSV file is empty. Please upload a valid file with data.", 
            "OK", 
            { duration: 5000 }
        );
        this.fileSelected = false;
        this.spinner.stop();
        return;

    }
      const headers = rows[0].split(',').map(header => header.trim()); // Extract headers
    const findMissingColumns=  requiredColumns.filter(col => !headers.includes(col));
    if(findMissingColumns.length>0){
      this.snackbar.open(`Columns [${findMissingColumns}] are missing in selected file.`,"OK", {
        duration: 5000,
    });
    this.fileSelected = false;
    this.spinner.stop();
    return;
    }
      const dataRows = rows.slice(1); // Exclude headers
      if (dataRows.length === 0) {
        this.snackbar.open("CSV file has no data or only empty rows.","OK", {
          duration: 5000,
      });
        this.fileSelected = false;
        this.spinner.stop();
        return;
    }
    let apiCalls: Promise<any>[] = [];
    console.log(dataRows)
      for (const row of dataRows) {
        // const values = row.split(',').map(value => value.trim());
        console.log(row)
        const values = this.parseCSVRow(row)
        console.log(values)
          let rowData: any = {};

          headers.forEach((header, index) => {
            const value = values[index]; // Get the value from the CSV row
            if ( header !== "fileName" &&
  header !== "setSplitObject" &&
  header !== "globalExtractionObject" &&
  header !== "globalExtractionObjectField" &&
  header !== "extractionObject" &&
  header !== "extractionObjectField" &&
  header !== "parentobjectfilename" &&
  header !== "parentobjectkeycolumn" &&
  header !== "requiredInDataLake" &&
  header !== "refreshInIncremental" &&
              (value === undefined || value.trim() === ""))
            { 
            
              this.spinner.stop();
              const objectName = values[headers.indexOf("object_name")] 
              this.snackbar.open(`Value is missing for column: ${header} in object : ${objectName}`, "OK", {
                  duration: 5000,
              });
           
          
              return; // Stop further execution for this row
          }
          if(header==="partition_start_position"||header==="partition_length"){
            const objectName = values[headers.indexOf("object_name")] 
            const numericValue = Number(value);
            if (isNaN(numericValue)){
              this.fileSelected=false
              this.spinner.stop();
              this.snackbar.open(`Value should be a number for column: ${header} in object : ${objectName}`, "OK", {
                duration: 5000,
            });
        
       
            return; // Stop further execution for this row
            }
            const numericValue1 = Number(value);
            if (!isNaN(numericValue1) && Number(value) < 0 ){
              this.fileSelected=false
              this.spinner.stop();
              this.snackbar.open(`Value should be a non-negative number for column: ${header} in object : ${objectName}`, "OK", {
                duration: 5000,
            });
        
       
            return; // Stop further execution for this row
            }
             
            } console.log(header)
            console.log(values)
              rowData[header] = values[index] // Handle missing values
          });
console.log(rowData)
          const groupName = rowData["group_name"] 
           const objectName = rowData["object_name"] 
           if(rowData["create_group"]==="Yes" || rowData["create_group"]==="No"){
             console.log(rowData["create_group"])
           }else{
            this.snackbar.open("Value for 'create_group' column should be only Yes/No","OK", {
              duration: 5000,
          });
            this.fileSelected = false;
            this.spinner.stop();
            return;
           }
          // Find existing group
          if(rowData["create_group"]==="Yes"){
            let existingGroup = this.objectGroupDataList.find(item => item.groupname === groupName);

            if (!existingGroup) {
              const columnValuesYesNo = {
                "split_required": values[headers.indexOf("split_required")],
                "fields_from_objectMetadata": values[headers.indexOf("fields_from_objectMetadata")]
            };
            // Find columns with invalid values
                 const invalidColumns = Object.keys(columnValuesYesNo).filter(
                   key => columnValuesYesNo[key] && !dropDownValues.includes(columnValuesYesNo[key])
                 );

                 if (invalidColumns.length > 0) {
                   this.snackbar.open(
                       `Invalid value found in column(s): ${invalidColumns.join(", ")} for object ${objectName}. Allowed values are 'Yes' or 'No'.`, 
                       "OK", 
                       { duration: 5000 }
                   );
                   this.fileSelected = false;
                   this.spinner.stop();
                   return;
                 }
                 if(!extractiontype.includes(values[headers.indexOf("group_extraction_type")])){
                  this.snackbar.open(
                    `Invalid value found in column group_extraction_type for object ${objectName}. Allowed values are 'Full' or 'Partial'.`, 
                    "OK", 
                    { duration: 5000 }
                );
                   this.fileSelected = false;
                   this.spinner.stop();
                   return;
                 }
                const extractionMethodKeys = {  
                "extraction_source": values[headers.indexOf("extraction_source")],
                "csv_extraction_source": values[headers.indexOf("csv_extraction_source")],
                }  
                const invalidExtractionColumns = Object.keys(extractionMethodKeys).filter(
                  key => extractionMethodKeys[key] && !extractionMethod.includes(extractionMethodKeys[key])
                );
                if (invalidExtractionColumns.length > 0) {
                  this.snackbar.open(
                      `Invalid value found in column(s): ${invalidExtractionColumns.join(", ")} for object ${objectName}. Allowed values are 'Loader' or 'VQL'.`, 
                      "OK", 
                      { duration: 5000 }
                  );
                  this.fileSelected = false;
                  this.spinner.stop();
                  return;
                }
                const requiredInDataLake = {
  requiredInDataLake: values[headers.indexOf("requiredInDataLake")],
  refreshInIncremental: values[headers.indexOf("refreshInIncremental")]
};

const invalidRequiredInDataLakeColumns = Object.keys(requiredInDataLake).filter(key => {
  const value = requiredInDataLake[key];

  // Skip empty/null/undefined values
  if (value === '' || value === null || value === undefined) {
    return false;
  }

  // Validate only when value exists
  return !dropDownValues.includes(value);
});

if (invalidRequiredInDataLakeColumns.length > 0) {
  this.snackbar.open(
    `Invalid value found in column(s): ${invalidRequiredInDataLakeColumns.join(", ")} for object ${objectName}. Allowed values are 'Yes' or 'No'.`,
    "OK",
    { duration: 5000 }
  );
  this.fileSelected = false;
  this.spinner.stop();
  return;
}

                if(!dropDownValues.includes(values[headers.indexOf("isParent")])){
                  this.snackbar.open(
                    `Invalid value found in column isParent for object ${objectName}. Allowed values are 'Yes' or 'No'.`, 
                    "OK", 
                    { duration: 5000 }
                );
                   this.fileSelected = false;
                   this.spinner.stop();
                   return;
                 }
                 if(!splitby.includes(values[headers.indexOf("splitby")])){
                   this.snackbar.open(
                    `Invalid value found in column splitby for object ${objectName}. Allowed values are id, case_number__v and local_case__v.`, 
                    "OK", 
                    { duration: 5000 }
                );
                   this.fileSelected = false;
                   this.spinner.stop();
                   return;
                 }
                
                existingGroup = {
                    description:values[headers.indexOf("description")],
                    groupname: groupName,
                    objectid: [], // Store unique object IDs
                    groupType: "Extraction Group",
                    groupExtractionType:values[headers.indexOf("group_extraction_type")],
                    setsSplitRequired: values[headers.indexOf("split_required")],
                    sourceDNS: this.sourceDns,
                    csvtojsoncsvpartitionname:values[headers.indexOf("partition_by")] ,
                    csvtojsonpartitionsubstringstartposition: values[headers.indexOf("partition_start_position")],
                    csvtojsonpartitionsubstringlength:values[headers.indexOf("partition_length")],
                    extractionsource:values[headers.indexOf("extraction_source")],
                    fieldsfromobjectmetadata: values[headers.indexOf("fields_from_objectMetadata")],
                    csvextractionsource: values[headers.indexOf("csv_extraction_source")],
                    splitby:values[headers.indexOf("splitby")]
                    
                };
                this.objectGroupDataList.push(existingGroup);
            
            }
  
            // Create object structure for objectid list
          let  objectid= values[headers.indexOf("object_name")].trim()
           let  isParent=values[headers.indexOf("isParent")]
            let filterCriteriaForExtraction = values[headers.indexOf("filter_criteria_for_extraction")].split('""').join('');
            let vqlCriteria = values[headers.indexOf("vql_criteria_for_extraction")].split('""').join('');
            let vqlCriteriaForIncremental = values[headers.indexOf("vql_criteria_for_incremental")].split('""').join('');
          
          let fileNames = values[headers.indexOf("fileName")]
          let fileName = "";
if (values[headers.indexOf("fileName")] !== undefined && values[headers.indexOf("fileName")].trim() !== "") {
  fileName = values[headers.indexOf("fileName")].split('""').join('');
}

let setSplitObject = "";
if (values[headers.indexOf("setSplitObject")] !== undefined && values[headers.indexOf("setSplitObject")].trim() !== "") {
  setSplitObject = values[headers.indexOf("setSplitObject")].split('""').join('');
}

let globalExtractionObjectField = "";
if (values[headers.indexOf("globalExtractionObjectField")] !== undefined && values[headers.indexOf("globalExtractionObjectField")].trim() !== "") {
  globalExtractionObjectField = values[headers.indexOf("globalExtractionObjectField")].split('""').join('');
}

let globalExtractionObject = "";
if (values[headers.indexOf("globalExtractionObject")] !== undefined && values[headers.indexOf("globalExtractionObject")].trim() !== "") {
  globalExtractionObject = values[headers.indexOf("globalExtractionObject")].split('""').join('');
}

let extractionObject = "";
if (values[headers.indexOf("extractionObject")] !== undefined && values[headers.indexOf("extractionObject")].trim() !== "") {
  extractionObject = values[headers.indexOf("extractionObject")].split('""').join('');
}

let extractionObjectField = "";
if (values[headers.indexOf("extractionObjectField")] !== undefined && values[headers.indexOf("extractionObjectField")].trim() !== "") {
  extractionObjectField = values[headers.indexOf("extractionObjectField")].split('""').join('');
}
let requiredInDataLake = "";
if (values[headers.indexOf("requiredInDataLake")] !== undefined && values[headers.indexOf("requiredInDataLake")].trim() !== "") {
  requiredInDataLake = values[headers.indexOf("requiredInDataLake")].split('""').join('');
} 
let refreshInIncremental = ""; 
if (values[headers.indexOf("refreshInIncremental")] !== undefined && values[headers.indexOf("refreshInIncremental")].trim() !== "") {
  refreshInIncremental = values[headers.indexOf("refreshInIncremental")].split('""').join('');
}

const dnsName = rowData["dnsName"];
let level = rowData["level"];
const parentobjectfilename = (rowData["parentobjectfilename"] || "").trim();

const parentobjectkeycolumn = (rowData["parentobjectkeycolumn"] || "").trim();


let sourceDnsId = null;

 const res = await firstValueFrom(this.service.dnsIdByName(dnsName));
 sourceDnsId = res;
  if(sourceDnsId === null || sourceDnsId === undefined){
   alert(`DNS Name '${dnsName}' not found. Please check the DNS Name provided for object: ${objectName}.`),
    this.fileSelected = false;
    this.spinner.stop();
    return;
  }
   
 
          const apiCall =  this.service.objectIdByName(objectid,dnsName).toPromise().then((res:any)=>{
            console.log(res);
                if (res === null){

                   console.log(`OBJECT NOT FOUND under DNS '${this.sourceDns}': '${objectid}'`);
                 this.fileSelected=false
                 this.snackbar.open(`object ${objectid} not present please check.`, "OK", {duration: 5000});
                 this.spinner.stop();
                 return;
      
    }else{
      objectid = res
      // "fileName","setSplitObject","globalExtractionObjectField","globalExtractionObject","extractionObject","extractionObjectField"
      let objectData = {
        objectid: objectid,
        isParent: isParent,
        filterCriteriaForExtraction: filterCriteriaForExtraction,
        vqlCriteria: vqlCriteria,
        vqlCriteriaForIncremental:vqlCriteriaForIncremental,
        fileName:fileName,
      setSplitObject:setSplitObject,
      globalExtractionObjectField:globalExtractionObjectField,
      globalExtractionObject:globalExtractionObject,
      extractionObject:extractionObject,
      extractionObjectField:extractionObjectField,
      level:level,
      parentobjectfilename:parentobjectfilename,
      parentobjectkeycolumn:parentobjectkeycolumn,
      sourceDnsId:sourceDnsId,
      requiredInDataLake:requiredInDataLake,
      refreshInIncremental:refreshInIncremental

    };

    // Add only unique object IDs
    if (!existingGroup.objectid.some(obj => obj.objectid === objectData.objectid)) {
        existingGroup.objectid.push(objectData);
    }else{
      this.snackbar.open(
        `Duplicate entry found for object: ${objectName} in group: ${groupName}. Each object must be unique within its group.`,
        "OK",
        { duration: 5000 }
    );
    
       this.fileSelected = false;
       this.spinner.stop();
       return;  
    }
    }

          })
          
            apiCalls.push(apiCall);
            
          }
          
      };
      
     // Wait for all API calls to complete
     await Promise.all(apiCalls);
      console.log("Final Report Creation Data List:", this.objectGroupDataList);
      if(this.objectGroupDataList.length===0){
        this.snackbar.open("At least one row in the 'create_group' column should have 'Yes'.","OK", {
          duration: 5000,
      });
        this.fileSelected = false;
        this.spinner.stop();
        return;
      }
console.log(this.objectGroupDataList)
for (let group of this.objectGroupDataList) {
  console.log(`Checking group '${group.groupname}' for parent objects...`);
  console.log("All objects in group:", JSON.stringify(group.objectid, null, 2));
  const parentObjects = group.objectid.filter(obj => obj.isParent === "Yes");

  if (parentObjects.length === 0) {
    this.snackbar.open(`Group '${group.groupname}' has no parent object.`, "OK", { duration: 5000 });
    this.fileSelected = false;
    this.spinner.stop();
    return; // Exits the function
  } else if (parentObjects.length > 1) {
    console.log(`Group '${group.groupname}' can have only one parent.`);
    this.snackbar.open(`Group '${group.groupname}' can have only one parent.`, "OK", { duration: 5000 });
    this.fileSelected = false;
    this.spinner.stop();
    return; // Exits the function
  }
}

      this.spinner.stop();
  };
 
  reader.readAsText(file); // Read the file as text
  
}


onSelectionSourceDNSForTemplate(){
  console.log(this.sourceDns + "<--- source dns for group creation")
  console.log(this.listOfSourceDNS)
  console.log(this.listOfSourceDNS[0].vaultConfigMstrId)
  console.log(this.reportCreationData.sourceDNS)
  // console.log(event.value)


  // this.validations_form = this.fb.group({
  //   sourceDNS: ["", Validators.required]
  // });
  // this.sourceDns = this.listOfSourceDNS[0].vaultConfigMstrId;
  // this.validations_form.get('sourceDNS')?.setValue(this.listOfSourceDNS[0].vaultConfigMstrId);
  // console.log(this.reportCreationData.sourceDNS+"]]]]]]]]]]]]]")
  
  this.sourceDns = this.reportCreationData.sourceDNS;
  console.log(this.sourceDns +"<--- source dns for group creation")
  this.dropdownSelected=true
//   this.spinner.start();
   //this.service.retrieveObjectsByDnsId(dnsName).subscribe((res:any) =>{
//     this.spinner.stop();
//     console.log(res);
//     if (res === null || res.length == 0){
//       this.dropdownSelected=false
//       this.snackbar.open("No Metadata Available for Selected DNS", "OK", {duration: 5000});
      
//     }else{
//       this.dropdownSelected=true
//       this.tablefields = res;
//       console.log(this.tablefields);
// debugger
// console.log(this.objectGroupDataList.length)
//        for(let i=0;i<this.objectGroupDataList.length;i++){
       
//         this.objectGroupDataList[i].sourceDNS = dnsName;
//         for(let k=0;k< this.objectGroupDataList[i].objectid.length;k++){
//           debugger
//           let objectPresent = false;
//           for(let j=0;j<this.tablefields.length;j++){
//             console.log(this.objectGroupDataList[i].objectid[k].objectid)
//             console.log(this.tablefields[j].objectname)
//             if(this.objectGroupDataList[i].objectid[k].objectid === this.tablefields[j].objectname){
//               this.objectGroupDataList[i].objectid[k].objectid = this.tablefields[j].id;
//               objectPresent=true
//               break;
//             }
//           }
//           if(objectPresent===false){
//             console.log("Object not present ---->>  "+ this.objectGroupDataList[i].objectid[k].objectid)
//             this.snackbar.open(`${this.objectGroupDataList[i].objectid[k].objectid} object not present please check.`, "OK", {duration: 5000});
//            this.dropdownSelected=false
           
//            console.log( this.validations_form)
//            this.validations_form.get('sourceDNS')?.reset();
//             return;
//           }
          
         
//         }
        
//        }
//      console.log(this.objectGroupDataList);
//     }
//   })


}

uploadGroupTemplate(){
  console.log("Inside upload grpup template and create the groups method")
  console.log(this.objectGroupDataList)

    
const levelMap = new Map<number, string>(); // Map<level, tenantId>

for (const obj of this.objectGroupDataList.flatMap(g => g.objectid)) {
  // const tenantId = obj.tenantid;
  const sourceDnsId = obj.sourceDnsId;
  const levelValue = obj.level;

  // Skip empty levels
  if (levelValue === null || levelValue === undefined || levelValue === '') continue;
  if(levelValue===0 || levelValue ==='0')
{
  alert("Level should be 1 or greater. Level 0 is not allowed.");

}
  // Validate numeric
  const levelNum = Number(levelValue);
  if (isNaN(levelNum)) {
alert("Level value should be a valid number");
    return;
  }

  // Check if same level exists for a different tenant
  if (levelMap.has(levelNum) && levelMap.get(levelNum) !== sourceDnsId) {
   alert(
     `Level value '${levelValue}' must be unique across different sources`
    );
    return;
  }

  if(obj.isParent ==="Yes" && obj.level !== '1'){
        alert("Level should be 1 for parent object.")
        return;
      }

      
  const level = Number(obj.level);
  const parentFile = obj.parentobjectfilename?.trim() || "";
  const parentKey  = obj.parentobjectkeycolumn?.trim() || "";
  if (level === 1 && (parentFile !== "" || parentKey !== "")) {
    //  Condition 1: Level 1 should NOT have parent fields
    alert("For level 1, parentobjectfilename and parentobjectkeycolumn are not required.");
    return;

  } else if ((parentFile !== "" && parentKey === "") || (parentKey !== "" && parentFile === "")) {

    // Condition 2: For other levels, both parent fields must be filled together
    alert(`Both Parent Object Filename and Parent Object Key Column are required together for ${obj.objectlabel}`);
    return;
  }

  // Store mapping of level → tenantId
  levelMap.set(levelNum, sourceDnsId);
}


  this.spinner.start();
  this.vaultObjectService.insertMstrObjectGroup(this.objectGroupDataList).subscribe(response => {
    // this.spinner.start();
    console.log(response)
    // checking if response is true or not
    if (response.error == true) {
      this.snackbar.open(response.statusMessage, "OK", {
        duration: 5000,

      });
      this.spinner.stop();
    }else{
      this.snackbar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      
      this.dialogref.close();
      this.cancel();
      this.onGridReady(this.params);
    }
})

}

resetFileInput(event: any) {
  event.target.value = ''; // Clear file input before selecting a new file
}
//  parseCSVRow(row) {
//   const regex = /(".*?"|[^",]+)(?=\s*,|\s*$)/g; // Matches text within quotes or plain text values
//   return row.match(regex)?.map(value => value.replace(/^"|"$/g, '')); // Remove extra quotes
//   }
  
  parseCSVRow(row: string): string[] {
    const result: string[] = [];
    let inQuotes = false;
    let value = '';

    for (let i = 0; i < row.length; i++) {
      const char = row[i];

      if (char === '"') {
        inQuotes = !inQuotes; // toggle inQuotes flag
        continue; // skip the quote character
      }

      if (char === ',' && !inQuotes) {
        result.push(value.trim()); // push collected value
        value = '';
      } else {
        value += char;
      }
    }

    result.push(value.trim()); // push last value
    return result;
  }




updateParentObjectFilename(value, id, params) { // parentobjectkeycolumn
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].parentobjectfilename = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].parentobjectfilename = value
      break;
    }
  }
}
updateparentobjectkeycolumn(value, id, params) { // parentobjectkeycolumn
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].parentobjectkeycolumn = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].parentobjectkeycolumn = value
      break;
    }
  }
}
updateFileNameValue(value, id, params) {
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].filename = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].filename = value
      break;
    }
  }
}
updateLevelValue(value, id, params) {
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].level = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].level = value
      break;
    }
  }
}
updateObjectnameValue(value, id, params) {
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].fileName == id) {
      this.selectedObjects[i].fileName = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].fileName == id) {
      this.reportCreationData.objectid[i].fileName = value
      break; 
    }
  }
}
updateParentObjectkeycolumnValue(value, id, params) {
   
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].parentobjectkeycolumn = value
      break;
    }
  } console.log("selected object from FileNameValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].parentobjectkeycolumn = value
      break; 
    }
  }
}


updateSetSplitObjectValue(value, id, params) {

  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].setSplitObject = value
      break;
    }
  } console.log("selected object from setsplitObject", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].setSplitObject = value
      break;
    }
  }

}

updateGlobalExtractionObjectValue(value, id, params) {

  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].globalExtractionObject = value
      break;
    }
  } console.log("selected object from GlobalExtractionObjectValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].globalExtractionObject = value
      break;
    }
  }
}

updateGlobalExtractionObjectFieldValue(value, id, params) {

  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].globalExtractionObjectField = value
      break;
    }
  } console.log("selected object from GlobalExtractionObjectFieldValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].globalExtractionObjectField = value
      break;
    }
  }
}

updateExtractionObjectValue(value, id, params) {

  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].extractionObject = value
      break;
    }
  } console.log("selected object from ExtractionObjectValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].extractionObject = value
      break;
    }
  }
}

updateExtractionObjectFieldValue(value, id, params) {

  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].extractionObjectField = value
      break;
    }
  } console.log("selected object from ExtractionObjectFieldValue", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].extractionObjectField = value
      break;
    }
  }
  }

  downloadObjectGroupTemplate(): void {
    // Define headers in your desired order
    const headers = [
      'object_name',
      'group_name',
      'description',
      'group_extraction_type',
      'split_required',
      'isParent',
      'fields_from_objectMetadata',
      'extraction_source',
      'csv_extraction_source',
      'filter_criteria_for_extraction',
      'vql_criteria_for_extraction',
      'vql_criteria_for_incremental',
      'partition_by',
      'partition_start_position',
      'partition_length',
      'splitby',
      'fileName',
      'setSplitObject',
      'globalExtractionObject',
      'globalExtractionObjectField',
      'extractionObject',
      'extractionObjectField',
      'create_group',
      'dnsName',
      'parentobjectfilename',
      'parentobjectkeycolumn',
      'level',
      'requiredInDataLake',
      'refreshInIncremental'
    ];

    // Create a single row with empty values
    const emptyRow = Object.fromEntries(headers.map(header => [header, '']));

    // Convert to CSV string using XLSX
    // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([emptyRow], { header: headers });
    // const csvOutput: string = XLSX.utils.sheet_to_csv(worksheet);
    // moving from xlsx to exceljs so this is XLSX utils and it's api is not useful
    const csvOutput = headers.join(',') + '\r\n' + headers.map(() => '').join(',') ;
    // Create a Blob for CSV and download
    const blob = new Blob([csvOutput], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'ObjectGroupTemplate.csv';
    document.body.appendChild(anchor);
    anchor.click();

    // Cleanup
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }

updateRequiredInDatalake(value, id, params) { // parentobjectkeycolumn
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].requiredInDataLake = value
      break;
    }
  } console.log("selected object from requiredInDataLake", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].requiredInDataLake = value
      break;
    }
  }
}
updaterefreshInIncremental(value, id, params) { // parentobjectkeycolumn
  
  for (let i = 0; i < this.selectedObjects.length; i++) {
    if (this.selectedObjects[i].id == id) {
      this.selectedObjects[i].refreshInIncremental = value
      break;
    }
  } console.log("selected object from refreshInIncremental", this.selectedObjects)

  for (let i = 0; i < this.reportCreationData.objectid.length; i++) {
    if (this.reportCreationData.objectid[i].objectid == id) {
      this.reportCreationData.objectid[i].refreshInIncremental   = value
      break;
    }
  }
}

}
